import { projectRequest } from 'api';
import { IUpdateAnnouncementPayload } from './types';

const updateAnnouncement = (id: number, payload: Omit<IUpdateAnnouncementPayload, 'id'>) => {
  return projectRequest(false, 'v2').put(`/announcement/${id}`, payload);
};

export default updateAnnouncement;
